import { Prisma } from '@prisma/client';
import { ImpactType } from '../impact';
import {
  PROJECT_PUBLIC_DETAIL_SELECT,
  PROJECT_PUBLIC_SELECT,
  PROJECT_PUBLIC_SUMMARY_SELECT,
  PROJECT_UPDATE_SELECT,
} from './project-selects';

type PublicProjectPayload = Prisma.ProjectGetPayload<{
  select: typeof PROJECT_PUBLIC_SELECT;
}>;

export type PublicProject = Omit<PublicProjectPayload, 'impactType'> & {
  impactType: ImpactType;
};

type PublicProjectSummaryPayload = Prisma.ProjectGetPayload<{
  select: typeof PROJECT_PUBLIC_SUMMARY_SELECT;
}>;

export type PublicProjectSummary = Omit<PublicProjectSummaryPayload, 'impactType'> & {
  impactType: ImpactType;
};

export type PublicProjectDetail = Omit<
  Prisma.ProjectGetPayload<{ select: typeof PROJECT_PUBLIC_DETAIL_SELECT }>,
  'impactType'
> & {
  impactType: ImpactType;
};

export type PublicProjectUpdate = Prisma.ProjectUpdateGetPayload<{
  select: typeof PROJECT_UPDATE_SELECT;
}>;

export type PublicProjectImage = PublicProject['images'][number];
export type PublicProjectLocation = PublicProject['locations'][number];
export type PublicProjectSdg = PublicProject['sdgs'][number];

export type ProjectWithPublicMetadata = PublicProject & {
  impactTotal: number;
  pendingImpactTotal: number;
  mostRecentlyFundedAt: Date;
};

export type ProjectUpdateWithProject = PublicProjectUpdate & {
  project: PublicProject;
};

const GOOGLE_PROJECT_MAP_ID = '1jI22Yex9nZrXr483mkOoUZa0J70gFT5J';

export const UNSPECIFIED_COUNTRY = 'Unspecified';

export type ProjectDictionary = {
  posts: Record<number, never>;
  projects: Record<number, PublicProjectSummary>;
};

export const getPrimaryProjectImage = (
  project: Pick<PublicProjectSummary, 'primaryImage' | 'images'>,
): PublicProjectImage | null => project.primaryImage ?? project.images[0] ?? null;

export const getProjectLocationLabel = (location?: Pick<PublicProjectLocation, 'region' | 'country'> | null): string =>
  [location?.region, location?.country].filter(Boolean).join(', ');

export const getProjectMapUrl = (location?: Pick<PublicProjectLocation, 'latitude' | 'longitude'> | null): string =>
  location
    ? `https://www.google.com/maps/d/viewer?mid=${GOOGLE_PROJECT_MAP_ID}&ll=${Number(location.latitude)}%2C${Number(
        location.longitude,
      )}&z=12`
    : '';

export const getPrimaryProjectLocation = (
  project: Pick<PublicProjectSummary, 'locations'>,
): PublicProjectLocation | undefined => project.locations[0];
